import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatLegacyDialogConfig as MatDialogConfig } from '@angular/material/legacy-dialog';

import { Store } from '@ngrx/store';

import { OrderListActions } from '@app/order-list/store/order-list.slice';
import { environment } from '@environments/environment';
import { ProductSearchResponseWithAmount } from '@search/interfaces/product-search-response-with-amount.interface';
import { ProductSearchActions } from '@search/store/search.slice';
import { convertDecimalToPercent } from '@shared/helpers/decimal-percent.helper';
import { isVerticalEllipsisActive } from '@shared/helpers/is-ellipsis-active.helper';
import { DialogService } from '@shared/services/dialog.service';
import { ProductSortimentActions } from '@sortiment/store/product-sortiment.slice';

import { SearchProductModalComponent } from '../search-product-modal/search-product-modal.component';

@Component({
  selector: 'app-search-result-card',
  templateUrl: './search-result-card.component.html',
  styleUrls: ['./search-result-card.component.scss'],
})
export class SearchResultCardComponent implements OnChanges {
  @Input() data!: ProductSearchResponseWithAmount;
  @Input() isSortiment?: boolean;

  readonly imageBaseUrl = `${environment.imageStorageUrl}`;
  readonly DICT_PATH = 'SEARCH.RESULT_CARD.';

  prevQuantity?: number;

  quantity?: number;

  isVerticalEllipsisActive = isVerticalEllipsisActive;

  constructor(private store: Store, private dialogService: DialogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data.amount !== this.quantity) {
      this.quantity = this.data.amount;
      this.prevQuantity = this.data.amount;
    }
  }

  onQuantityChange(quantity?: number) {
    if (quantity) {
      this.updateCart(quantity);
    }
  }

  openProductModal() {
    // TODO request beszállítók
    this.store.dispatch(
      ProductSearchActions.getActiveProduct.trigger({
        packagingUnitId: this.data.packagingUnitId!,
      })
    );
    const dialogConfig: MatDialogConfig = {
      panelClass: 'search-product-modal',
      minWidth: '80%',
      maxWidth: '90%',
      minHeight: 'unset',
      data: {
        product: this.data,
      },
    };
    this.dialogService.openDialog(SearchProductModalComponent, dialogConfig);
  }

  addToCart() {
    this.store.dispatch(
      OrderListActions.addItems.trigger({
        request: {
          packagingUnitIds: [this.data?.packagingUnitId ?? ''],
          amount: 1,
        },
      })
    );
  }

  onInputBlur() {
    if (!this.quantity) {
      this.store.dispatch(
        OrderListActions.removeItem.trigger({
          id: this.data.orderListId ?? '',
        })
      );
    } else if (this.quantity !== this.prevQuantity) {
      this.updateCart(this.quantity);
    }
  }

  addOneItemToCart() {
    this.updateCart((this.quantity ?? 0) + 1);
  }

  removeOneItemToCart() {
    if (this.quantity === 1) {
      this.store.dispatch(
        OrderListActions.removeItem.trigger({
          id: this.data.orderListId ?? '',
        })
      );
    } else {
      this.updateCart((this.quantity ?? 0) - 1);
    }
  }

  updateCart(value: number) {
    this.store.dispatch(
      OrderListActions.updateOrderListFromSearch.trigger({
        body: {
          orderListBulk: { [this.data.packagingUnitId ?? '']: value },
        },
      })
    );
  }

  addSortiment() {
    this.store.dispatch(
      ProductSortimentActions.addProductToSortiment.trigger({
        packagingUnitId: this.data?.packagingUnitId ?? '',
      })
    );
  }

  calcAlcoholLevel(level: number): number {
    return convertDecimalToPercent(level);
  }
}
